if($('.type-detail').length){
    
$(".p-detail-inner-header h1").insertBefore($(".p-info-wrapper .stars-wrapper"));


if($(".products-related").length) {
    
$(".products-related").insertAfter($(".p-info-wrapper .social-buttons-wrapper"));
}
}


